<template>
  <v-app>
    <v-main class="pa-4">
      <suspense>
        <order-main />
        <template #fallback>
          <div class="loading-screen">
            <div class="loading-screen__wrapper">
              <span>Daten werden geladen...</span>
              <v-progress-linear color="primary" indeterminate class="mt-2" />
            </div>
          </div>
        </template>
      </suspense>
      <v-row justify="start" no-gutters>
        <v-col cols="auto">
          <label class="text-caption font-weight-medium pl-1">
            FTTH Bestellstrecke - {{ appVersion }}
          </label>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import OrderMain from './components/order-main.vue';

const appVersion = computed(() => `v${__APP_VERSION__}`);
</script>
<style lang="scss">
  @use './assets/sass/variables.sass';
  $color-pack: false;

  .loading-screen {
    height: 100vh;
    margin: auto;
    width: 500px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  .loading-screen__wrapper {
    width: 100%;
  }
</style>
